import {
  Button,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Progress,
} from '@commenda/kakashi';

interface SuccessStepProps {
  successCount: number;
  totalRows: number;
  onClose: () => void;
}

export const SuccessStep = ({
  successCount,
  totalRows,
  onClose,
}: SuccessStepProps) => (
  <>
    <DialogHeader className="flex flex-col gap-xs items-start">
      <DialogTitle>Messages Sent</DialogTitle>
      <DialogDescription>
        All {successCount} message(s) have been sent successfully.
      </DialogDescription>
    </DialogHeader>

    <div className="px-2xl py-xl flex flex-col items-center justify-center gap-md">
      <div className="w-full">
        <Progress value={100} accent="success" />
      </div>
      <p className="txt-small-medium text-text-secondary">
        {successCount} of {totalRows} messages sent successfully
      </p>
    </div>

    <DialogFooter>
      <Button variant="primary" onClick={onClose}>
        Close
      </Button>
    </DialogFooter>
  </>
);
